import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroupFilesComponent } from './form-group-files.component';
import {FilesInputModule} from "../../../components/files-input/files-input.module";
import {FormsModule} from "@angular/forms";
import {NgxPopperModule} from "ngx-popper";
import {ValidateModule} from "../../validate/validate.module";



@NgModule({
  declarations: [FormGroupFilesComponent],
  exports: [
    FormGroupFilesComponent
  ],
  imports: [
    CommonModule,
    FilesInputModule,
    FormsModule,
    NgxPopperModule,
    ValidateModule
  ]
})
export class FormGroupFilesModule { }
